// src/lib/observability.js — GlitchTip (Sentry-compatible) error monitoring.
// Reativação do monitoramento do monólito (Beta 1.32.0): carrega o SDK do Sentry por
// CDN (sem dependência de build) e inicializa apontando para o GlitchTip self-hosted.
// DSN configurável via VITE_GLITCHTIP_DSN, com fallback para o projeto existente.

const DSN = import.meta.env.VITE_GLITCHTIP_DSN
  || 'https://be8ea32deff74cee9d145bc4c40e4ecf@errors.angular-erp.com.br/1';
const SDK_URL = 'https://browser.sentry-cdn.com/8.55.0/bundle.min.js';

let _ready = false;
let _pendingUser = null;

export function initObservability() {
  if (!DSN) return;
  const host = location.hostname;
  if (['localhost', '127.0.0.1', '0.0.0.0'].includes(host)) return; // não monitora dev local
  if (document.querySelector('script[data-sentry]')) return;        // idempotente

  const s = document.createElement('script');
  s.src = SDK_URL;
  s.crossOrigin = 'anonymous';
  s.setAttribute('data-sentry', '1');
  s.onload = () => {
    try {
      if (!window.Sentry) return;
      window.Sentry.init({
        dsn: DSN,
        environment: host === 'app.angular-erp.com.br' ? 'production' : 'staging',
        release: 'angular-erp-vite',
        sampleRate: 1.0,
        tracesSampleRate: 0.1,
        ignoreErrors: [
          /^Script error\.?$/,
          /^ResizeObserver loop/,
          'Non-Error promise rejection captured',
          'Network request failed',
          'Failed to fetch',
          'Load failed',
          /chrome-extension:\/\//,
          /moz-extension:\/\//,
        ],
        beforeSend(event) {
          if (['localhost', '127.0.0.1', '0.0.0.0'].includes(location.hostname)) return null;
          if (event.request && event.request.headers) {
            delete event.request.headers.authorization;
            delete event.request.headers.cookie;
          }
          return event;
        },
      });
      _ready = true;
      if (_pendingUser) { setObservabilityUser(_pendingUser.user, _pendingUser.profile); _pendingUser = null; }
    } catch (e) { /* silencioso — não deixa o monitoramento quebrar o app */ }
  };
  s.onerror = () => { /* CDN/instância indisponível — segue sem monitoramento */ };
  document.head.appendChild(s);
}

export function setObservabilityUser(user, profile) {
  if (!user) return;
  if (!_ready || !window.Sentry) { _pendingUser = { user, profile }; return; }
  try {
    window.Sentry.setUser({
      id: user.id,
      email: user.email,
      role: profile?.tipo_usuario,
      empresa_id: profile?.empresa_id,
    });
  } catch (e) { /* silencioso */ }
}

export function clearObservabilityUser() {
  if (_ready && window.Sentry) { try { window.Sentry.setUser(null); } catch (e) {} }
  _pendingUser = null;
}
